import {
  TiptapBase,
  BulletList,
  ListItem,
  OrderedList,
  Bold,
  Italic,
  Underline,
  Strike,
  Link,
  History,
  AutoHideToolbar,
  ClearContent,
  ToggleMessageControls,
  Placeholder,
  Mention,
} from '@/js/util/tiptap/extensions';

import { LinksHandlers, ListsHandlers, TextFormattingHandlers } from '@/js/util/tiptap/handlers';

const placeholder = 'Leave a comment about this task...';

export default class CompactConfig {
  get extensions() {
    const CommentBodyPlaceholder = Placeholder[0].configure({ placeholder });

    return [
      ...TiptapBase,
      ...BulletList,
      ...ListItem,
      ...OrderedList,
      ...Bold,
      ...Italic,
      ...Underline,
      ...Strike,
      ...Link,
      ...History,
      ...AutoHideToolbar,
      ...ClearContent,
      ...ToggleMessageControls,
      ...Mention,
      ...[CommentBodyPlaceholder],
    ];
  }

  get handlers() {
    return {
      ...LinksHandlers,
      ...ListsHandlers,
      ...TextFormattingHandlers,
    };
  }
}
